export const CONSENT_KEY = "cookieConsent";
export const CONSENT_EVENT = "gtx:consent-changed";

export const DEFAULT_CONSENT = { essential: true, analytics: true, preferences: true, marketing: true };
export const ESSENTIAL_ONLY = { essential: true, analytics: false, preferences: false, marketing: false };

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? { marketing: false, ...JSON.parse(raw) } : null;
  } catch {
    return null;
  }
}

export function setConsent(prefs) {
  const value = { ...prefs, essential: true };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  localStorage.setItem("cookieConsentDate", new Date().toISOString());
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  return value;
}
